module.exports = __webpack_public_path__ + "static/media/memoriesLogo.8e9763ff.png";